// @ts-ignore
const TempStars = window.TempStars || {}

// Keeping track of all the events that are being tracked in the mixpanel analytics
// TODO: Normalize the event names to be used in the analytics across the codebase
// TODO: Remove `(string & {})` once all events are listed here & moved to TypeScript
// TODO: Add not only event names but also the data that is being tracked for each event
type AnalyticsEvent = (string & {})
| "accept offer"
| "add payment info"
| "add_payment_details"
| "Autobook_Hours_Set"
| "autoLogin/landing - error"
| "decline offer"
| "DO_Autobook_Clicked"
| "instabook shift"
| "Instabook_Button_Clicked"
| "Instabook_Confirmed"
| "log in"
| "login - error"
| "logout"
| "mark shift as completed"
| "Password Reset - error"
| "pay invoice"
| "post shift"
| "resubmitted shift"
| "Select-Route"
| "send offer"
| "sign-up - acknowledge market terms"
| "sign-up - complete dental office details form"
| "sign-up - complete dental office form"
| "sign-up - complete profile"
| "sign-up - complete user info form"
| "sign-up - Confirm user type"
| "sign-up - create account"
| "sign-up - error"
| "sign-up - Failed to Save Profile"
| "sign-up - Failed to Save Qualifications and Skills"
| "sign-up - Saved Qualifications and Skills"
| "sign-up - view start page"
| "submit rating"
| "Support Agent Logged In"
| "upload resume"
| "view offer detail"
| "view offers"
| "view_office_createAccount"
| "view_talent_createAccount"
| "Viewed Job Board"
| "Viewed My Stats"
| "ClearDent_reffered_view"

export const Analytics = {
    track: (eventName: AnalyticsEvent, data: any) => {
        console.log(`Track event: ${eventName}`);
        TempStars.Analytics.track(eventName, data);
    }
}